<template>
  <base-modal modal-content-class="modal_change_info modal_glow">
    <div class="content">
      <form @submit.prevent="changeGovernorate()">
        <h3 class="title">{{ getTranslations.home_modals_change_governorate_text }}</h3>

        <governorate-selection
          v-model="selectedGovernorate"
          @change="validateGovernorate"
        ></governorate-selection>

        <div  class="error_text"
              v-show="hasErrors && showErrors">
          {{ getMessage(result) }}
        </div>

        <div class="outline_fancy_btn update_info">
          <button type="submit"
                  @click.prevent="changeGovernorate()"
                  class="fancy_btn">
            {{ getTranslations.home_modals_change_governorate_update }}
          </button>
        </div>


        <p class="succ_upd" v-show="!hasErrors && result">
          {{ getMessage(result) }}
        </p>
      </form>
    </div>
  </base-modal>
</template>

<script>
import {mapGetters, mapState, mapActions, mapMutations} from 'vuex';
import BaseModal from "../../common/modal/BaseModal";
import GovernorateSelection from "../../common/formInput/GovernorateSelection";


export default {
  name: 'change-login-pin',
  components: {
    BaseModal,
    GovernorateSelection
  },
  data(){
    return{
      selectedGovernorate: '',
      hasErrors: false,
      showErrors: false,
      result: '',
    };
  },
  methods: {
    ...mapActions('profile', [
      'updateGovernorate',
    ]),
    ...mapMutations('common', [
      'storeGovernorate',
    ]),
    validateGovernorate() {
      this.hasErrors = !this.selectedGovernorate;
      this.showErrors = this.hasErrors;
      if (this.hasErrors) {
        this.result = 'home_profile_profile_edit_msg_warning_invalid_governorate';
      } else {
        this.result = '';
      }
    },
    changeGovernorate(){
      if (!this.selectedGovernorate) {
        this.hasErrors = true;
        this.showErrors = true;
        this.result = 'home_profile_profile_edit_msg_warning_invalid_governorate';
        return;
      }
      this.updateGovernorate({ governorate: this.selectedGovernorate })
        .then(() => {
          this.hasErrors = false;
          this.storeGovernorate(this.selectedGovernorate);
          this.result = 'home_profile_profile_edit_governorate_updated';
        })
        .catch((error) => {
          this.hasErrors = true;
          this.showErrors = true;
          this.result = 'home_profile_profile_edit_server_unvailable';
        });
    },
    getMessage(key) {
      if (key === 'SERVER_ERROR') return key;
      return this.getTranslations[key] || '';
    }
  },
  computed: {
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapState('profile', [
      'jwtInVuex',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),

  },
};

</script>



// WEBPACK FOOTER //
// src/components/home/modals/ChangeGovernorate.vue